import { useEffect, useState } from "react";

const errorMessages: Record<string, string> = {
  AbortError: "Camera or microphone cannot be used (unknown cause)",
  NotAllowedError: "Cannot join video chat without camera and microphone permissions",
  NotFoundError: "Cannot join video chat without camera and microphone",
  NotReadableError: "Cannot access camera or microphone due to hardware problem",
  OverconstrainedError: "Cannot find a suitable camera or microphone",
  SecurityError: "Access denied",
};

export default function useUserMedia(constraints: MediaStreamConstraints | null) {
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    let canceled = false;
    if (!constraints) return setStream(null);

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        if (canceled) return;
        setStream(stream);
      })
      .catch((reason) => {
        if (canceled) return;
        if (reason instanceof DOMException && reason.name in errorMessages) {
          setError(errorMessages[reason.name]);
        } else if (reason instanceof TypeError) {
          setError("Access denied");
        } else {
          setError("Unknown Error");
          console.error(reason);
        }
      });
    return () => {
      canceled = true;
    };
  }, [constraints]);

  // close media device on unmount
  useEffect(() => () => stream?.getTracks().forEach((t) => t.stop()), [stream]);

  return { stream, error };
}
